import React, { useState } from "react";
import SideMenu from "../../components/admin/SideMenu";
import UserLists from "../../components/admin/lists/UserLists";
import UserEdit from "../../components/admin/edit/UserEdit";

const AdminUsers = () => {
  const [editUserId, setEditUserId] = useState<string | null>(null);

  const handleEditUser = (userId: string) => {
    setEditUserId(userId);
  };

  const handleBack = () => {
    setEditUserId(null);
  };

  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />
        <div className="main-contents">
          <h3>ユーザー</h3>
          {editUserId ? (
            <UserEdit userId={editUserId} onBack={handleBack} />
          ) : (
            <UserLists onEdit={handleEditUser} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;
